import { WorkAssignment } from "../entities/WorkAssignment";
import { LogUserPositionResponse } from "../models/log-user-position/log-user-position-response-interface";
import { CompletedSyncAction, SavedSyncAction } from "../models/sync-action/sync-action-interface";
import { DateTimeType } from "../utils/date-time-helper";

export enum AppEventType {
  DATE_CHANGED = 'DATE_CHANGED',
  OPEN_TIME_RECORD_MODAL = 'OPEN_TIME_RECORD_MODAL',
  OPEN_MEAL_BREAK_MODAL = 'OPEN_MEAL_BREAK_MODAL',
  REFRESH_CLOSED_TIME_RECORD_MODAL = 'REFRESH_CLOSED_TIME_RECORD_MODAL',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGOUT_SUCCESS = 'LOGOUT_SUCCESS',
  INITIAL_SYNC_DATA_AVAILABLE = 'INITIAL_SYNC_DATA_AVAILABLE',
  SYNC_COMPLETE = 'SYNC_COMPLETE',
  SYNC_ACTION_QUEUED = 'SYNC_ACTION_QUEUED',
  SYNC_ACTION_COMPLETED = 'SYNC_ACTION_COMPLETED',
  FORM_DEFINITIONS_SYNC_COMPLETED = 'FORM_DEFINITIONS_SYNC_COMPLETED',
  SYNCED_TEAM_DATA = 'SYNCED_TEAM_DATA',
  SYNCED_PROJECT_DATA = 'SYNCED_PROJECT_DATA',
  USER_CURRENT_POSITION_LOGGED = 'USER_CURRENT_POSITION_LOGGED',
  RETRY_LOCATION_REQUESTED_BY_USER = 'RETRY_LOCATION_REQUESTED_BY_USER',
}

export interface AppEventData {
  [AppEventType.DATE_CHANGED]: DateTimeType;
  [AppEventType.OPEN_TIME_RECORD_MODAL]: number;
  [AppEventType.OPEN_MEAL_BREAK_MODAL]: number;
  [AppEventType.REFRESH_CLOSED_TIME_RECORD_MODAL]: null;
  [AppEventType.LOGIN_SUCCESS]: null;
  [AppEventType.LOGOUT_SUCCESS]: null;
  [AppEventType.INITIAL_SYNC_DATA_AVAILABLE]: null;
  [AppEventType.SYNC_COMPLETE]: null;
  [AppEventType.SYNC_ACTION_QUEUED]: SavedSyncAction<any>;
  [AppEventType.SYNC_ACTION_COMPLETED]: CompletedSyncAction<any>;
  [AppEventType.FORM_DEFINITIONS_SYNC_COMPLETED]: null;
  [AppEventType.SYNCED_TEAM_DATA]: { teamId: number };
  [AppEventType.SYNCED_PROJECT_DATA]: { projectId: number };
  [AppEventType.USER_CURRENT_POSITION_LOGGED]: LogUserPositionResponse | null;
  [AppEventType.RETRY_LOCATION_REQUESTED_BY_USER]: null;
}
